import React from 'react'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'
import { ArrowDown2 } from 'iconsax-react'

import ButtonMenu from '../ButtonMenu'

import { fetchTimezones } from '@SonarCX/slices/timezone'
import useStyles from './styles'

type TimezonesMenuProps = {
  id?: string
  selected: string
  onSelect: (x: string) => void
  className?: string
  disabled?: boolean
}

const TimezonesMenu: React.FC<TimezonesMenuProps> = ({
  selected,
  onSelect,
  className,
  disabled,
  ...props
}) => {
  const dispatch = useAppDispatch()
  const tzSelector = useAppSelector(storeState => storeState.timezone)
  const { timezones, current } = tzSelector

  const classes = useStyles({ disabled })

  React.useEffect(() => {
    if (!tzSelector.loaded && !tzSelector.loading) {
      dispatch(fetchTimezones())
    }
  }, [tzSelector, dispatch])

  const getTimezoneName = React.useCallback(
    key => {
      let tzKey = key
      if ((tzKey?.length ?? 0) === 0) {
        tzKey = current
      }
      const tz = timezones.find(zone => zone.key === tzKey)
      return tz?.value ?? 'No Timezone'
    },
    [current, timezones]
  )
  const selectedTimezone = React.useMemo(
    () => getTimezoneName(selected),
    [getTimezoneName, selected]
  )

  if (disabled) {
    return selectedTimezone
  }

  return (
    // @ts-ignore
    <ButtonMenu
      options={timezones.map(tz => tz.key)}
      onSelect={onSelect}
      selected={selected || current}
      renderFunc={getTimezoneName}
      className={className ?? classes.root}
      disabled={disabled}
      {...props}
    >
      {selectedTimezone}

      <ArrowDown2 className={classes.icon} />
    </ButtonMenu>
  )
}

export default TimezonesMenu
